const FEATURE_TYPE = {
  TENANCY: 9,
  APP: 0,
  MENU: 1,
  BTN: 2
};

const ROLE_TYPE_MAP = {
  MANAGER: 1,
  GENERAL: 2
};

const APP_CATEGORY = {
  NATIVE: 1,
  INCLUDE: 2,
  REDIRECT: 3
};

const ROLE_TYPE_LIST = [
  {
    value: ROLE_TYPE_MAP.MANAGER,
    label: "管理员"
  },
  {
    value: ROLE_TYPE_MAP.GENERAL,
    label: "普通角色"
  }
];

const YES_NO_STATE = [{value: 1, label: "是"}, {value: 0, label: "否"}];
const CLIENT_TYPE = [
  {value: 1, label: "管理端"},
  {value: 2, label: "员工端"},
  {value: 3, label: "业务主端"}
];

const PAGE_SIZE = 20;
const ID_CARD_REG = /^[1-9][0-9]{5}(19|20)[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|31)|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}([0-9]|x|X)$/
const LARGE_MODAL_SIZE = "900px";
const NORMAL_MODAL_SIZE = "600px";
const SMALL_MODAL_SIZE = "400px";

const SCROLL_CONFIG = {
  freeScroll: true,
  scrollbar: {
    fade: true,
    interactive: true
  },
  bounce: {
    bottom: false,
    left: false,
    right: false,
    top: false
  },
  zoom: true,
  mouseWheel: true
};

const PAGE_LAYOUT = "total, sizes, prev, pager, next";
const PAGE_SIZES = [5, 10, 20, 30, 50, 100];
// const PAGE_LAYOUT1='total, sizes, prev, pager, next'

const ORDER_STATUS = {
  NOTSTARTED: 1,
  ALREADYSTARTED: 2,
  BEUNDERCONSTRUCTION: 3,
  COMPLETED4: 4,
  SHUTDOWN: 5,
  NODELIVERIES: 11,
  DELIVERED: 12,
  PARTIALINSTALLATION: 13,
  COMPLETED14: 14,
  RETURNEDGOODS: 15
};
const SETTING_LOG_TYPE = [
  {
    value: 1,
    label: "组织机构",
    disabled: false
  },
  {
    value: 2,
    label: "项目",
    disabled: false
  },
  {
    value: 3,
    label: "员工",
    disabled: false
  },
  {
    value: 4,
    label: "银行卡",
    disabled: false
  }
];

export {
  FEATURE_TYPE,
  ROLE_TYPE_MAP,
  ROLE_TYPE_LIST,
  PAGE_SIZE,
  LARGE_MODAL_SIZE,
  NORMAL_MODAL_SIZE,
  SMALL_MODAL_SIZE,
  SCROLL_CONFIG,
  PAGE_LAYOUT,
  PAGE_SIZES,
  YES_NO_STATE,
  CLIENT_TYPE,
  ORDER_STATUS,
  APP_CATEGORY,
  SETTING_LOG_TYPE,
  ID_CARD_REG
};
